import React, {useMemo} from "react";

import "../../css/legend.css";
import {Card, ListGroup} from "react-bootstrap";
import {useOverlayContext} from "../../contexts/OverlayContext";
import {useFileRegions} from "../../hooks/useJsonLoader";
import {hexToStringRgba} from "../../utils/colour";
import LegendCircle from "../LegendCircle";
import LegendLine from "../LegendLine";

const OverlayLegend = () => {
  const {overlayResults, hoveredRegions, setHoveredRegions} = useOverlayContext();

  const regions = useFileRegions();

  /**
   * Mapping region name to Region data, to lookup region coordinates.
   */
  const regionLookup = useMemo(
    () => Object.fromEntries(regions?.map(region => [region.name, region]) ?? []),
    [regions]);

  const isHighlighted = (domain: string) =>
    hoveredRegions.includes(regionLookup[domain]);

  return <Card id="legend" className="text-white">
    <Card.Body>
      <Card.Title as={"h5"}>Legend</Card.Title>
      <ListGroup variant="flush">
        {overlayResults?.overlay.map(result => (
          <ListGroup.Item
            key={result.name}
            className="d-flex align-items-center text-white border-0 py-0"
          >
            <LegendCircle colour={result.colour} size={".8em"}/>
            {result.verbose_name}
          </ListGroup.Item>
        ))}
      </ListGroup>
      <hr/>
      <Card.Title as={"h5"}>Bioprocess-Enriched Network Regions</Card.Title>
      <ListGroup variant="flush">
        {Object.keys(overlayResults?.enrichment.enriched_domains ?? {}).map((domain: string) => (
          <ListGroup.Item
            key={domain}
            className="d-flex align-items-center text-white border-0 py-0"
            onMouseEnter={() => setHoveredRegions([regionLookup[domain]])}
            onMouseLeave={() => setHoveredRegions([])}
            style={{
              backgroundColor: isHighlighted(domain) ? hexToStringRgba(regionLookup[domain].colour, .35) : "transparent",
              boxShadow: isHighlighted(domain) ? `inset 0 0 5px 2px ${regionLookup[domain].colour}` : "none",
            }}
          >
            <LegendLine colour={regionLookup[domain].colour} height={2}/>
            {domain}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card.Body>
  </Card>
}

export default OverlayLegend;